import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=72840d27&scoped=true&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72840d27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72840d27')) {
      api.createRecord('72840d27', component.options)
    } else {
      api.reload('72840d27', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=72840d27&scoped=true&", function () {
      api.rerender('72840d27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Account/Children/ChangePassword.vue"
export default component.exports